export type ChannelType = 'SMS' | 'EMAIL';

export type SearchFieldType = 'entity_id' | 'entity_identifier' | 'entity_name';

export const CHANNEL_IDS: Record<ChannelType, number> = {
    EMAIL: 2,
    SMS: 4,
};

export interface DefaultTimeslot {
    is_company_level: boolean;
    start_hour: string;
    end_hour: string;
}

export interface DefaultTimeslots {
    SMS: DefaultTimeslot;
    EMAIL: DefaultTimeslot;
}

export interface EntityTimeslot {
    timeslot_id: number | null;
    start_hour: string;
    end_hour: string;
}

export interface TimeslotEntityRow {
    entity_id: number;
    entity_name: string;
    entity_identifier: string;
    city: string;
    SMS: EntityTimeslot;
    EMAIL: EntityTimeslot;
}

export interface GetAllTimeslotsResponse {
    totalItems: number;
    member: TimeslotEntityRow[];
}
